/**
 * Connection details for the Support org's chat-flow SDK app. That app does not
 * exist yet, so every value is empty until ops fills the env in — the panel checks
 * `isBuddyFlowConfigured` before honouring the feature flag and stays on the
 * aiassist transport until then, rather than signing requests with a blank key.
 */
export interface BuddyFlowConfig {
  appId: string
  appKey: string
  /** Pinned by env, not taken from the session: the flow app lives in one region. */
  region: string
  /** Gateway origin that fronts the contacto-uploader. */
  apiBaseUrl: string
  /** hodor's chat-gateway prefix for the runner front door. */
  runnerBaseUrl: string
  /** Signed as the device and sent as CLIENT-TYPE; a wire contract with the gateway. */
  clientType: string
}

const FLOW_CLIENT_TYPE = 'web-sdk'

// A getter rather than module-level consts: Vite inlines the literals at build time
// either way, and a getter lets a test flip the env to exercise the configured path.
export const getBuddyFlowConfig = (): BuddyFlowConfig => ({
  appId: process.env.REACT_APP_BUDDY_FLOW_APP_ID || '',
  appKey: process.env.REACT_APP_BUDDY_FLOW_APP_KEY || '',
  region: process.env.REACT_APP_BUDDY_FLOW_REGION || '',
  apiBaseUrl: process.env.REACT_APP_BUDDY_FLOW_API_URL || '',
  runnerBaseUrl: process.env.REACT_APP_BUDDY_FLOW_RUNNER_URL || '',
  clientType: FLOW_CLIENT_TYPE,
})

export const isBuddyFlowConfigured = (config: BuddyFlowConfig = getBuddyFlowConfig()): boolean =>
  Boolean(
    config.appId && config.appKey && config.region && config.apiBaseUrl && config.runnerBaseUrl,
  )

/** Region-resolved origin with no trailing slash, so the signed url is byte-stable. */
export const resolveFlowBase = (base: string, region: string): string =>
  base.replace('{{region}}', region).replace(/\/+$/, '')
